var render, staticRenderFns
import script from "./label.vue?vue&type=script&lang=tsx&"
export * from "./label.vue?vue&type=script&lang=tsx&"
import style0 from "./label.vue?vue&type=style&index=0&id=b2859882&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2859882",
  null
  
)

/* custom blocks */
import block0 from "../lang.yaml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fworkspace%2Fsource-code%2Fcomponents%2Fdu-input%2Fcomponents%2Flabel.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports